import { render, staticRenderFns } from "./UnsplashImageBrowser.vue?vue&type=template&id=21a2059a&"
import script from "./UnsplashImageBrowser.vue?vue&type=script&lang=ts&"
export * from "./UnsplashImageBrowser.vue?vue&type=script&lang=ts&"
import style0 from "./UnsplashImageBrowser.vue?vue&type=style&index=0&id=21a2059a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports